import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

const Root = styled('div')(({ theme }) => ({
  '& > .logo-icon': {
    transition: theme.transitions.create(['width', 'height'], {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
  '& > .badge': {
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
}));

function Logo() {
  return (
    <Root className="flex items-center">
      <Link to="/">
        <img
          className="h-32"
          src={`assets/images/logo/${process.env.REACT_APP_COMPANY_NAME}/logo-with-text.svg`}
          alt="logo"
        />
      </Link>
    </Root>
  );
}

export default Logo;
